import React, { useEffect, useState } from 'react';
import NavigationBar from '../components/NavigationBar';
import bg2 from '../assets/bgLogo2.jpg';
import GlassPopup from '../components/GlassPopup';

const POPUP_STORAGE_KEY = "homePopupLastClosedAt";
const POPUP_RESET_HOURS = 24;

const MainLayout = ({ children }) => {
    const [isPopupOpen, setIsPopupOpen] = useState(false);

    useEffect(() => {
        const lastClosedAt = localStorage.getItem(POPUP_STORAGE_KEY);
        const now = Date.now();
        const resetTime = POPUP_RESET_HOURS * 60 * 60 * 1000;

        if (!lastClosedAt) {
            setIsPopupOpen(true);
            return;
        }

        const elapsed = now - Number(lastClosedAt);

        if (elapsed >= resetTime) {
            localStorage.removeItem(POPUP_STORAGE_KEY);
            setIsPopupOpen(true);
        }
    }, []);

    const handleClosePopup = () => {
        localStorage.setItem(POPUP_STORAGE_KEY, Date.now().toString());
        setIsPopupOpen(false);
    };

    return (
        <>
            <div style={{ backgroundImage: `url(${bg2})`, backgroundRepeat: "no-repeat", backgroundPosition: "center", backgroundSize: "cover", height: "100vh", width: "100%" }}> {/*  Immagine del logo infodent con le particelle */}
                <NavigationBar />
                <GlassPopup
                    isOpen={isPopupOpen}
                    onClose={handleClosePopup}
                    imageAlt="Promozione Home"
                    maxWidth="1000px"
                />
                <div>
                    {children}
                </div>
            </div>
        </>
    )
}

export default MainLayout